// src/modules/app-views/crm/pages/Kanban/components/modals/ColumnPropertiesModal/tabs/AutomationTab.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useCallback, useState } from 'react';
import { Form, Input, InputNumber, Select, Space } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const AutomationTab = ({ form }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  // ANTD v6 fix: controlled open state ensures dropdown closes on first click
  const [openSelect, setOpenSelect] = useState(false);

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleSelect = useCallback(() => {
    setOpenSelect(false);
  }, []);

  const handleOpenChange = useCallback(visible => {
    setOpenSelect(visible);
  }, []);

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  // Watch form fields to compute the info text reactively
  const operation = Form.useWatch('sparks_operation', form);
  const amount = Form.useWatch('sparks_amount', form);

  const operationOptions = [
    { value: '', label: translateX('no_movement') },
    { value: 'credit', label: translateX('credit') },
    { value: 'debit', label: translateX('debit') },
  ];

  const infoText =
    operation === 'credit'
      ? translateX('consultant_will_earn_sparks', { amount: amount || 1 })
      : operation === 'debit'
        ? translateX('consultant_will_lose_sparks', { amount: amount || 1 })
        : null;

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Form form={form} layout="vertical">
    <div className="mt-3">
      {/* ── Sparks Credits ── */}
      <Card
        title={
          <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <ThunderboltOutlined />
            {translateX('sparks_credits')}
          </span>
        }
      >
        <div style={{ marginBottom: 16 }}>
          <div style={{ marginBottom: 4, fontWeight: 500 }}>{translateX('operation')}</div>
          <Form.Item name="sparks_operation" noStyle>
            <Select
              style={{ width: '100%' }}
              open={openSelect}
              onSelect={handleSelect}
              onOpenChange={handleOpenChange}
              options={operationOptions}
            />
          </Form.Item>
        </div>

        {!!operation && (
          <div style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 4, fontWeight: 500 }}>
              {translateX('amount_spark_coins')}
            </div>
            <Space.Compact style={{ width: '100%' }}>
              <Form.Item name="sparks_amount" noStyle>
                <InputNumber min={1} style={{ flex: 1 }} />
              </Form.Item>
              <Input readOnly value="sparkCoins" style={{ width: 'auto', pointerEvents: 'none' }} />
            </Space.Compact>
          </div>
        )}

        {infoText && (
          <div className="text-muted" style={{ fontSize: 13 }}>
            {infoText}
          </div>
        )}
      </Card>
    </div>
    </Form>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default AutomationTab;
